<template>
  <div class="atom-button d-flex">
    <b-button
      class="w-100 d-flex align-items-center justify-content-center"
      :class="{
        disabled: isDisable,
        round: isRound,
        'padding-icon': (iconLeft || iconRight) && styleInIcon,
      }"
      :variant="variant"
      :style="styleInButton"
      :size="buttonSize"
      @click="clickButton()"
    >
      <feather-icon v-if="iconLeft" :style="styleInIcon" :icon="iconLeft" />
      <span
        v-if="$scopedSlots.default"
        :class="{
          'atom-button--margin-left': iconLeft,
          'atom-button--margin-right': iconRight,
        }"
      >
        <slot></slot>
      </span>
      <feather-icon v-if="iconRight" :style="styleInIcon" :icon="iconRight" />
    </b-button>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue"

export default {
  name: "AtomButton",
  components: {
    BButton,
  },
  props: {
    buttonId: {
      type: String,
      required: true,
    },
    buttonStyle: {
      type: String,
      required: false,
      default: "filled",
      //value = ["filled", "border", "flat"]
    },
    buttonColor: {
      type: String,
      required: false,
      default: "primary",
      //value = ["primary", "secondary", "success", "danger", "warning", "info", "dark"]
    },
    styleInButton: {
      type: String,
      required: false,
      default: null,
    },
    isOnlyIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconLeft: {
      type: String,
      required: false,
      default: "",
    },
    iconRight: {
      type: String,
      required: false,
      default: "",
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false,
    },
    isRound: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonSize: {
      type: String,
      required: false,
      default: "md",
      validator: (value) => {
        return ["sm", "md", "lg"].includes(value)
      },
    },
  },
  emits: ["click"],
  computed: {
    variant() {
      //border
      if (this.buttonStyle == "border") {
        if (this.isDisable) return "outline-secondary"
        else return "outline-" + this.buttonColor
      }
      //flat
      else if (this.buttonStyle == "flat") {
        if (this.isDisable) return this.buttonStyle + "-secondary"
        else return this.buttonStyle + "-" + this.buttonColor
      }

      //filled
      else {
        if (this.isDisable) return "secondary"
        else return this.buttonColor
      }
    },
    styleInIcon() {
      if (this.$slots.text) return ""
      else return "width:20px; height:20px;"
    },
  },
  methods: {
    clickButton() {
      this.$emit("click", this.buttonId)
    },
  },
}
</script>

<style lang="scss" scoped>
.atom-button ::v-deep .btn-sm,
.btn-group-sm > .btn {
  padding: 0.4rem !important;
}

.atom-button--margin-left {
  margin-left: 10px;
}

.atom-button--margin-right {
  margin-right: 10px;
}

.disabled {
  pointer-events: none;
}

.padding-icon {
  padding: 8px;
}
</style>
